module.exports = __webpack_public_path__ + "img/user2-160x160.48625f54.png";